import React from 'react';
import Reveal from './atoms/reveal';
import Note from './organisms/blog_card_note';
import Qiita from './organisms/blog_card_qiita';
import TechScore from './organisms/blog_card_techscore';

const CARDS = [
    { key: 'note', Component: Note },
    { key: 'qiita', Component: Qiita },
    { key: 'techscore', Component: TechScore },
];

function Blog() {
    return (
        <section id="blog" className="home-section parallax text-center py-10" data-stellar-background-ratio="0.5">
            <div className="flex items-center justify-center py-5">
                <div className="container relative z-30">
                    <Reveal className="section-heading text-center">
                        <h2 className="text-4xl text-center font-semibold pb-6">Blog</h2>
                    </Reveal>
                    <div className="grid gap-3 grid-flow-row-dense grid-cols-3 justify-center xl:px-40 px-10 items-start">
                        {CARDS.map(({ key, Component }, i) => (
                            <Reveal
                                key={key}
                                variant="scale"
                                delay={i * 120}
                                className="col-span-3 lg:col-span-1 min-w-0"
                            >
                                <Component />
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );

}

export default Blog;
